// re.rejouis.fr — questionnaire de la demande (écran Vérifications) : pourquoi le
// client se sépare de ses jouets, depuis combien de temps il les avait, et un petit
// mot pour l'équipe. Les libellés sont ceux des options Airtable (Demandes :
// raison_separation, anciennete) → ne pas les renommer sans renommer l'option
// Airtable, sinon le typecast crée une option en double et les stats se scindent.
// Partagé avec netlify/functions/demande.js (liste blanche serveur).

export const RAISONS = [
  'La sensation produite ne me convient pas',
  'La taille ne me convient pas',
  'J’ai trouvé mieux et ne l’utilise plus',
  'Suite à une séparation',
  'Je n’utilise plus de sextoys',
  'Je l’ai reçu en cadeau et je n’en veux pas',
  'Je veux renouveler ma collection',
  'C’est une erreur de colis/commande',
  'Autre raison',
];

export const ANCIENNETES = [
  'Moins de 3 mois',
  '3 à 6 mois',
  '6 mois à 1 an',
  '1 à 2 ans',
  '2 à 5 ans',
  'Plus de 5 ans',
];

export const COMMENTAIRE_MAX = 1000;

// Apostrophes typographiques à l'écran, droites dans Airtable (options existantes).
const versAirtable = (s) => s.replace(/’/g, "'");

/** Nettoie les réponses (liste blanche) → champs prêts pour Airtable, ou null si vide. */
export function questionnairePourAirtable(q) {
  if (!q || typeof q !== 'object') return null;
  const raisons = (Array.isArray(q.raisons) ? q.raisons : []).filter((r) => RAISONS.includes(r));
  const anciennete = ANCIENNETES.includes(q.anciennete) ? q.anciennete : '';
  const commentaire = typeof q.commentaire === 'string' ? q.commentaire.trim().slice(0, COMMENTAIRE_MAX) : '';
  if (!raisons.length && !anciennete && !commentaire) return null;
  return {
    ...(raisons.length ? { raison_separation: [...new Set(raisons)].map(versAirtable) } : {}),
    ...(anciennete ? { anciennete } : {}),
    ...(commentaire ? { commentaire_client: commentaire } : {}),
  };
}

// Les réponses sont saisies AVANT la connexion : on les garde le temps de
// l'aller-retour OAuth (comme le choix newsletter), puis on les oublie à l'envoi.
const CLE = 'rejouis_reprise_questionnaire';

export function memoriserQuestionnaire(q) {
  try { localStorage.setItem(CLE, JSON.stringify(q)); } catch { /* stockage indisponible */ }
}

export function lireQuestionnaire() {
  try { return JSON.parse(localStorage.getItem(CLE)) || null; } catch { return null; }
}

export function oublierQuestionnaire() {
  try { localStorage.removeItem(CLE); } catch { /* rien */ }
}
